import React from 'react'

import { getEntity, getHeaderData, getFooterData } from '@api/index'

import { default as normalizeHeaderData } from '@models/Header'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeArchiveStatements } from '@models/ArchiveStatements'
import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import normalizeMetadata from '@models/Metadata'

import { Col, Container, Row } from '@/atoms/Grid'
import Breadcrumb from '@/molecules/Breadcrumb'
import { ArchiveList, ArchiveSidebar } from '@/organisms'

import Layout from '@/organisms/Layout'

export const getStaticProps = async () => {
  const [header, footer, statements] = await Promise.all([
    getHeaderData(),
    getFooterData(),
    getEntity({ entity: 'statements' }),
  ])

  return {
    props: {
      metadata: normalizeMetadata(statements.data.seo),
      breadcrumb: normalizeBreadcrumb([{ label: 'Prospetti e Rendiconti' }]),
      footer: normalizeFooterData(footer),
      header: normalizeHeaderData(header),
      content: normalizeArchiveStatements(statements.data),
    },
  }
}

const ArchiveStatements = ({
  metadata,
  breadcrumb,
  header,
  footer,
  content,
}) => {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
      colorScheme='primaryLight'
    >
      <Breadcrumb items={breadcrumb} />
      <Container>
        <Row>
          <Col
            xs={12}
            lg={4}
          >
            <ArchiveSidebar
              {...content.sidebar}
              entity='prospetti-e-rendiconti'
            />
          </Col>
          <Col
            xs={12}
            lg={8}
          >
            <ArchiveList
              {...content.list}
              entity='prospetti-e-rendiconti'
              ctaLabel='Elenco'
              listSlice={6}
              minimizedList
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default ArchiveStatements
